<template>
  <!-- Mobile Backdrop Overlay -->
  <div 
    v-if="isOpen" 
    class="fixed inset-0 bg-black/50 z-40 md:hidden transition-opacity" 
    @click="$emit('update:isOpen', false)"
  ></div>

  <!-- Sidebar -->
  <aside 
    class="fixed inset-y-0 left-0 z-50 w-64 bg-white dark:bg-gray-800 border-r border-gray-200 dark:border-gray-700 transform transition-transform duration-300 ease-in-out md:translate-x-0"
    :class="isOpen ? 'translate-x-0' : '-translate-x-full'"
  >
    <!-- Header -->
    <div class="flex h-16 items-center px-6 border-b border-gray-200 dark:border-gray-700">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-[#035a76] dark:text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-4l-2 2v-2z" />
      </svg>
      <span class="ml-3 text-xl font-bold text-[#035a76] dark:text-white">Communication</span>
    </div>

    <!-- Navigation -->
    <nav class="overflow-y-auto h-[calc(100%-4rem)] scrollbar-thin scrollbar-thumb-gray-300 dark:scrollbar-thumb-gray-600">
      <ul class="space-y-1 p-3">
        
        <!-- Dashboard -->
        <li>
          <RouterLink 
            to="/com-dashboard" 
            class="flex items-center px-3 py-2.5 rounded-lg text-gray-700 dark:text-gray-200 hover:bg-[#74bd54] hover:text-white transition-colors duration-200"
            active-class="router-link-active"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
            </svg>
            Dashboard
          </RouterLink>
        </li>

        <!-- Users -->
        <li>
          <RouterLink 
            to="/com-users" 
            class="flex items-center px-3 py-2.5 rounded-lg text-gray-700 dark:text-gray-200 hover:bg-[#74bd54] hover:text-white transition-colors duration-200"
            active-class="router-link-active"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
            </svg>
            Users
          </RouterLink>
        </li>

        <!-- Pictures -->
        <li>
          <RouterLink 
            to="/staff-pictures" 
            class="flex items-center px-3 py-2.5 rounded-lg text-gray-700 dark:text-gray-200 hover:bg-[#74bd54] hover:text-white transition-colors duration-200"
            active-class="router-link-active"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            Staff Pictures
          </RouterLink>
        </li>

        <!-- Onboarding Form -->
        <li>
          <RouterLink 
            to="/com/onboarding"
            class="flex items-center px-3 py-2.5 rounded-lg text-gray-700 dark:text-gray-200 hover:bg-[#74bd54] hover:text-white transition-colors duration-200"
            active-class="router-link-active"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
            </svg>
            Onboarding Form
          </RouterLink>
        </li>

        <!-- Information -->
        <li>
          <RouterLink 
            to="/com/personal-info" 
            class="flex items-center px-3 py-2.5 rounded-lg text-gray-700 dark:text-gray-200 hover:bg-[#74bd54] hover:text-white transition-colors duration-200"
            active-class="router-link-active"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
            Information
          </RouterLink>
        </li>

                <li>
         <RouterLink 
           to="/com/leaves" 
           class="flex items-center px-3 py-2.5 rounded-lg text-gray-700 dark:text-gray-200 hover:bg-[#74bd54] hover:text-white transition-colors duration-200"
           active-class="router-link-active"
         >
           <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
             <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 2v4M16 2v4M3 10h18M5 4h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V6a2 2 0 012-2z" />
           </svg>
           Leaves
         </RouterLink>
        </li>

      </ul>
    </nav>
  </aside>
</template>

<script setup>
defineProps({
  isOpen: {
    type: Boolean,
    required: true
  }
});

// Emit update event for v-model:isOpen support
defineEmits(['update:isOpen']);
</script>

<style scoped>
.router-link-active {
  background-color: #74bd54;
  color: white !important;
  font-weight: 600;
}

/* Ensure submenu active links also have white icons (if you add dropdowns later) */
.router-link-active svg {
  color: white !important;
}
</style>